<template>
<div :style="listHeight">
    <el-scrollbar style="height: 100%">
        <el-row>
            <el-col :span="14">
                <template>
                    <el-table :data="tableData" style="width: 100%" @row-click="rowClick">
                        <el-table-column prop="TARGETUSERNAME" label="群组名称"></el-table-column>
                    </el-table>
                </template>
            </el-col>
            <el-col :span="10" class="chatRecord">
                <div v-for="item in chatRecord" :key="item.key">
                    <div class="one">
                        <span class="name">{{item.name}}</span>
                        <span class="time">{{item.time}}</span>
                    </div>
                    <div>
                        <span class="text">{{item.text}}</span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-scrollbar>
 
</div>
</template>

<script>

import {
    GetAllMessageBySessionId,
    GetAllSessionsByTaskId
} from "@/api/modules/basicData/task";
import $http from "@/api/index";

export default {
    components: {
    },
    data() {
        return {
            tableData: [],
            allSessions: [],
            chatRecord: [],
         
        };
    },
    created: function () {
        let a = $(window).height();
        this.listHeight = "height:" + (a - 130) + "px;";
    },
    methods: {
        initalTask: function () {
            this.chatRecord = [];
            GetAllSessionsByTaskId(this.task.ID).then(res1 => {
                this.allSessions = res1;
                this.tableData = this.uniqueArray(res1, "TARGETUSERID");
            });
        },
      
        uniqueArray(array, key) {
            var result = [array[0]];
            for (var i = 1; i < array.length; i++) {
                var item = array[i];
                var repeat = false;
                for (var j = 0; j < result.length; j++) {
                    if (item[key] == result[j][key]) {
                        repeat = true;
                        break;
                    }
                }
                if (!repeat) {
                    result.push(item);
                }
            }
            return result;
        },
        rowClick(row, column, event) {
            this.promise().then(val => {
                val.sort(function (a, b) {
                    return b.newTime > a.newTime ? -1 : 1;
                });
                val.forEach(c => {
                    if (c.id == row.TARGETUSERID) {
                        this.chatRecord.push(c);
                    }
                });
            });
        },
        promise() {
            return new Promise((resolve, reject) => {
                let arr = [];
                let sessionsArr = [];
                this.allSessions.forEach(c => {
                    GetAllMessageBySessionId(c.ID).then(res2 => {
                        if (c.ID == res2[0].SessionID) {
                            res2[0].id = c.TARGETUSERID;
                        }
                        arr.push({
                            name: c.CREATEUSERNAME,
                            time: this.createTimeFormat(c.CREATETIME),
                            newTime: this.dateToTime(c.CREATETIME),
                            id: res2[0].id,
                            key: c.ID,
                            text: res2[0].Text,
                            prototype: res2[0].Prototype
                        });
                    });
                });
                setTimeout(() => {
                    resolve(arr);
                    this.chatRecord = [];
                }, 500);
            });
        },
        dateToTime(str) {
            return new Date(this.createTimeFormat(str).replace(/-/g, "/")).getTime();
        },
        createTimeFormat(time) {
            //格式化时间
            return time ? time.replace("T", " ").substr(0, 19) : "";
        }
    },
    computed: {
        task: function () {
            return this.$store.state.task.curTask;
        }
    },
    watch: {}
};
</script>

<style scoped>
.chatRecord {
    box-sizing: border-box;
    padding: 15px;
    background-color: #fff;
    height: 100%;
    overflow: auto;
}

.chatRecord>div {
    margin-top: 10px;
}

.one {
    color: blue;
}
</style>
